export const COL_USERS = 'users';
export const COL_ANALYTICS_USERS = 'analytics_users';
export const COL_CONVERSATION = 'conversation';
export const COL_TENANT = 'tenant';
export const COL_API_KEYS = 'api_keys';
export const COL_BRIEFING_SUBSCRIPTION = 'briefing_subscription';
export const PUBLIC_URL = 'https://botbakery.app';
